<template>
  <div class="wrapper">
    <div class="content" style="background-color: rgba(0, 0, 0, 0.9); border-radius: 10px;">
      <h4 class="group">THE AMERICAN FREIGHT GROUP</h4>
      <h1 class="big">Big or Small</h1>
      <h1 id="ship">We Ship It All</h1>
      <p>We provide you with full package services, from bidding on your favorite cars in the US
        auctions and delivering to your desired locations.</p>
      <button class="button"
        style="background-color:#ED254E; border: none; padding: 8px; border-radius: 5px; cursor: pointer; display: flex; align-items: center; justify-content: center;">
        <div class="d-flex" style="display: flex; align-items: center; justify-content: center;">
          <h6 style="font-weight: 300; color: #fafafa; margin: 0 10px 0 0;">LET’S TALK</h6>
          <font-awesome-icon :icon="['fas', 'arrow-right']" :size="'1x'" style="color: #fafafa" />
        </div>
      </button>
    </div>
    <video height="800" width="100%" loop autoplay muted preload="auto">
      <source src="../assets/Video/AfgShipping_video.mp4" type="video/mp4"> Your browser does not support the video tag.
    </video>
  </div>
  <Offer />
  <Grid />
  <Partners />
  <Coverage />
  <VTracking />
  <Faq />
  <Technology />
  <Aboutus />
  <Contactus />
</template>

<script>
import Aboutus from './../components/Aboutus.vue';
import Coverage from './../components/Coverage.vue';
import VTracking from '../components/VTracking.vue';
import Technology from './../components/Technology.vue';
import Contactus from './../components/Contactus.vue';
import Services from './../components/Services.vue';
import Faq from './../components/Faq.vue';
import Partners from './../components/Partners.vue';
import Grid from './../components/Gridblock.vue';
import Howitworks from './../components/Howitworks.vue';
import Offer from './../components/Offer.vue';

export default {
  name: "Home",
  components: {
    Offer,
    Grid,
    Howitworks,
    Partners,
    Coverage,
    VTracking,
    Technology,
    Aboutus,
    Faq,
    Services,
    Contactus,
  },
}
</script>

<style>
/* Animation Starts */
.content {
  opacity: 0;
  /* Start with 0 opacity */
  transform: translateX(-100%);
  /* Start off-screen to the left */
  animation: slideIn 2s forwards ease-out;
  /* Slide in animation */
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-100%);
    /* Start from off-screen left */
  }

  to {
    opacity: 1;
    transform: translateX(0);
    /* End at its original position */
  }
}

/* Animation Ends */

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}

.wrapper {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.group {
  color: #ED254E;
  font-weight: 500;
}

.big {
  color: #1974d2;
  font-size: 33px;
  font-weight: 600;
}

.we {
  color: white;
  font-size: 33;
  font-weight: bolder;
}

.content {
  position: absolute;
  top: 30%;
  left: 8%;
  transform: translateY(-50%);
  color: white;
  padding: 20px;
  max-width: 600px;
  font-family: Montserrat;
}

video {
  width: 100%;
  height: 100vh;
  object-fit: cover;
}

@media (max-width: 767px) {
  .content {
    left: 5%;
    max-width: 90%;
  }

  .group {
    font-size: 13px;
  }

  .big {
    font-size: 24px;
  }

  h6 {
    font-size: 14px;
  }

  video {
    height: 100vh;
  }

  .wrapper p {
    font-size: 12px;
  }

  #ship {
    font-size: 35px;
  }
}
</style>
